/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { GEOS } from 'core/utils/constants';
/**
 *
 * `PageTerraform` is the dashboard page for the Terraform route in HCP.
 *
 *
 * ```
 * <Page::Terraform
 *   @model={{this.model}}
 * />
 * ```
 *
 * @class PageTerraform
 *
 */

export default class PageTerraformComponent extends Component {
  @service config;
  @service userContext;

  get deployGeo() {
    return this.config.app?.deployGeo ?? GEOS.US;
  }
}
